module.exports = __webpack_public_path__ + "static/media/ui-icons-recipes-on.79f8e192.svg";